<div class="pt-3 pr-20 pb-3 pl-20 bg-white rounded-4 mt-20">

    @if (hasError()) {
        <div class="text-large leading-relaxed">I wasn't able to
            <strong>{{ displayName() }}</strong>:
        </div>
    } @else {
        <div class="text-large leading-relaxed">Please confirm I have permission to
            <strong>{{ displayName() }}</strong> on your behalf.
        </div>
    }
    @if (updateWatchlistDetails(); as details) {
        <ycn-update-watchlist-confirmation-details [details]="details" />
    }
    @if (editPortfolioDetails(); as details) {
        <ycn-edit-portfolio-confirmation-details [details]="details" />
    }
    @if (alertDetails(); as details) {
        <ycn-alert-confirmation-details [details]="details" />
    }
    @if (hasError()) {
        <div class="row mt-3 mb-3">
            <div class="col-12">
                <button class="btn btn-secondary btn-block" (click)="dismiss()">Dismiss</button>
            </div>
        </div>
    } @else {
        <div class="row mt-3 mb-10">
            <div class="col-6">
                <button class="btn btn-secondary btn-block" (click)="reject()">Reject</button>
            </div>
            <div class="col-6">
                <button class="btn btn-primary btn-block" (click)="authorize()">Allow</button>
            </div>
        </div>
        <label class="custom-control custom-checkbox">
            <input [(ngModel)]="alwaysApply" class="custom-control-input" type="checkbox"><span class="custom-control-indicator"></span><span
                class="custom-control-description">Always apply this answer</span>
        </label>
    }
</div>
